//context to manage styles in the view survey components
import { createContext } from 'react';

const StylesContext = createContext();

export default StylesContext;
